// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public//assets//images/job-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-panel {
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.20);
  box-shadow: 0px 2px 6px 0px rgba(5, 27, 96, 0.20);
  backdrop-filter: blur(7.5px);
  width: 310px;
  height: 532px;
  overflow-y: auto;
  /* display: grid; */
}

.center-img {
  width: 104px;
  height: 115px;
  margin: auto;
  margin-top: 80%;
}

.text {
  color: white;
  text-align: center;
  font-family: 'Urbanist';
  font-size: 16px;
}

.content {
  align-items: center;
  display: grid;
  width: 60%;
  margin: auto;
}

.ep-row {
  padding: 8px;
  display: flex;
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.20);
  width: 100%;
  height: 80px;
  align-items: center;
  cursor: pointer;
}

.dp {
  width: 50px;
  height: 50px;
  border-radius: 10px;
}

.name {
  color: var(--White, #FFF);
  font-family: Urbanist;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.14px;
}

.role {
  color: var(--White, #FFF);
  font-family: Urbanist;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.1px;
  opacity: 0.6;
}

.dist-box {
  width: auto;
  height: 50px;
  border-radius: 10px;
  background: rgba(6, 239, 197, 0.24);
  padding: 5px;
}

.dist {
  color: #06EFC5;
  text-align: center;
  font-family: Urbanist;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
}

.kms {
  color: white;
  text-align: center;
  font-family: Urbanist;
  font-size: 8px;
}

.mob-card {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.20);
  box-shadow: 0px 2px 6px 0px rgba(5, 27, 96, 0.20);
  backdrop-filter: blur(7.5px);
  /* width: 250px; */
  height: 100%;
  margin-right: 10px;
}

.horizontal-slider {
  width: 100%;
  max-width: 500px;
  height: 50px;
  /* border: 1px solid grey; */
}

.example-thumb {
  font-size: 0.9em;
  text-align: center;
  background-color: white;
  cursor: pointer;
  border-radius: 50px;
  height: 18px;
  width: 18px;
  top: -6px
}

.example-track {
  position: relative;
  background: #38BBF4;
  height: 2px;
  border-radius: 10px;
}

.example-track.example-track-1 {
  background: white;
}

.horizontal-slider {
  height: 15px;
}

.cancel-btn {
  color: var(--Red, #EB5757);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.16px;
  margin-top: 8%;
}

.job-icon-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 70px;
  width: 70px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  place-items: center;
  place-content: center;
}

.avatar-marker {
  height: 30px;
  width: 30px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  place-items: center;
  place-content: center;
  border-radius: 50px;
}

@media only screen and (min-width:501px) {
  .control-panel-mobile {
    display: none;
  }
}

@media only screen and (max-width:500px) {
  .dp {
    width: 40px;
    height: 40px;
  }

  .dist-box {
    width: auto;
    height: 40px;
    padding: 2px;
  }

  .dist {
    font-size: 15px;
  }

  .kms {
    font-size: 7px;
    margin-top: -2px;
  }

  .ep-row {
    height: auto;
    border: none;
  }

  .control-panel-mobile {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 100%;
    overflow-x: auto !important;
    flex-wrap: nowrap !important;
    display: flex !important;
    height: auto;
    scrollbar-width: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Home/map.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,qCAAqC;EACrC,iDAAiD;EACjD,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,iDAAiD;EACjD,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yDAAsE;EACtE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;IACxB,YAAY;IACZ,gCAAgC;EAClC;AACF","sourcesContent":[".control-panel {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.20);\n  box-shadow: 0px 2px 6px 0px rgba(5, 27, 96, 0.20);\n  backdrop-filter: blur(7.5px);\n  width: 310px;\n  height: 532px;\n  overflow-y: auto;\n  /* display: grid; */\n}\n\n.center-img {\n  width: 104px;\n  height: 115px;\n  margin: auto;\n  margin-top: 80%;\n}\n\n.text {\n  color: white;\n  text-align: center;\n  font-family: 'Urbanist';\n  font-size: 16px;\n}\n\n.content {\n  align-items: center;\n  display: grid;\n  width: 60%;\n  margin: auto;\n}\n\n.ep-row {\n  padding: 8px;\n  display: flex;\n  border-bottom: 1.5px solid rgba(255, 255, 255, 0.20);\n  width: 100%;\n  height: 80px;\n  align-items: center;\n  cursor: pointer;\n}\n\n.dp {\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n}\n\n.name {\n  color: var(--White, #FFF);\n  font-family: Urbanist;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 0.14px;\n}\n\n.role {\n  color: var(--White, #FFF);\n  font-family: Urbanist;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: 0.1px;\n  opacity: 0.6;\n}\n\n.dist-box {\n  width: auto;\n  height: 50px;\n  border-radius: 10px;\n  background: rgba(6, 239, 197, 0.24);\n  padding: 5px;\n}\n\n.dist {\n  color: #06EFC5;\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.kms {\n  color: white;\n  text-align: center;\n  font-family: Urbanist;\n  font-size: 8px;\n}\n\n.mob-card {\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.20);\n  box-shadow: 0px 2px 6px 0px rgba(5, 27, 96, 0.20);\n  backdrop-filter: blur(7.5px);\n  /* width: 250px; */\n  height: 100%;\n  margin-right: 10px;\n}\n\n.horizontal-slider {\n  width: 100%;\n  max-width: 500px;\n  height: 50px;\n  /* border: 1px solid grey; */\n}\n\n.example-thumb {\n  font-size: 0.9em;\n  text-align: center;\n  background-color: white;\n  cursor: pointer;\n  border-radius: 50px;\n  height: 18px;\n  width: 18px;\n  top: -6px\n}\n\n.example-track {\n  position: relative;\n  background: #38BBF4;\n  height: 2px;\n  border-radius: 10px;\n}\n\n.example-track.example-track-1 {\n  background: white;\n}\n\n.horizontal-slider {\n  height: 15px;\n}\n\n.cancel-btn {\n  color: var(--Red, #EB5757);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.16px;\n  margin-top: 8%;\n}\n\n.job-icon-bg {\n  background-image: url('../../../../public//assets//images/job-bg.png');\n  height: 70px;\n  width: 70px;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  display: flex;\n  place-items: center;\n  place-content: center;\n}\n\n.avatar-marker {\n  height: 30px;\n  width: 30px;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  display: flex;\n  place-items: center;\n  place-content: center;\n  border-radius: 50px;\n}\n\n@media only screen and (min-width:501px) {\n  .control-panel-mobile {\n    display: none;\n  }\n}\n\n@media only screen and (max-width:500px) {\n  .dp {\n    width: 40px;\n    height: 40px;\n  }\n\n  .dist-box {\n    width: auto;\n    height: 40px;\n    padding: 2px;\n  }\n\n  .dist {\n    font-size: 15px;\n  }\n\n  .kms {\n    font-size: 7px;\n    margin-top: -2px;\n  }\n\n  .ep-row {\n    height: auto;\n    border: none;\n  }\n\n  .control-panel-mobile {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    width: 100%;\n    overflow-x: auto !important;\n    flex-wrap: nowrap !important;\n    display: flex !important;\n    height: auto;\n    scrollbar-width: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
